// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.media-image{\n    overflow:hidden;\n    max-height: 12em;\n}\n", ""]);
// Exports
module.exports = exports;
